import axios from "axios";

const api = axios.create({ baseURL: process.env.VUE_APP_ENDPOINT_PUBLIC_API, timeout: 540000 });

api.interceptors.request.use((config) => {
  config.headers.domain = `public.${process.env.VUE_APP_HOST}`;
  config.headers["Content-Type"] = `application/json`;
  config.headers["Access-Control-Allow-Origin"] = `*`;

  return config;
});

export default api;
